import { render, staticRenderFns } from "./SpecificInstruction.vue?vue&type=template&id=a0c00912&scoped=true"
import script from "./SpecificInstruction.vue?vue&type=script&lang=js"
export * from "./SpecificInstruction.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/W9_form/specific.css?vue&type=style&index=0&id=a0c00912&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c00912",
  null
  
)

export default component.exports